import { Directive, HostListener, inject, Input } from '@angular/core';
import { BillingUsageService } from 'src/app/views/my-space/billing-usage/billing-usage.service';

@Directive({
  selector: '[appAiRestrictedHover]',
  standalone: true,
})
export class AiRestrictedHoverDirective {
  @Input() appAiRestrictedHover = true;

  private billingService = inject(BillingUsageService);

  @HostListener('mouseenter')
  onMouseEnter() {
    if (this.appAiRestrictedHover) {
      this.billingService.aiRestrictedAlertTriggered.set(true);
    }
  }
}